export default "__VITE_ASSET__DqBrh5KT__"